import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export function formatPrice(value: number, currency: string, locale: string): string {
	return new Intl.NumberFormat(locale, {
		style: "currency",
		currency: currency,
		minimumFractionDigits: 0,
	}).format(value);
}

export function displayPrice(price: number, currency: string | undefined, locale: string): string {
	return Intl.NumberFormat(locale, {
		style: "currency",
		currency: currency || "EUR",
		minimumFractionDigits: 0,
	}).format(price);
}

export function displayPromo(
	amount: number,
	type: "percentage" | "fixed",
	currency: string | undefined,
	locale: string,
): string {
	if (type === "percentage") {
		return `+ ${amount}%`;
	}
	return `+ ${displayPrice(amount, currency, locale)}`;
}

export function parseDDMMYYYY(text: string): { day: number; month: number; year: number } | null {
	const date = dayjs(text, "DD/MM/YYYY", true);
	if (!date.isValid()) return null;

	return {
		day: date.date(),
		month: date.month() + 1,
		year: date.year(),
	};
}

export function toISOFromDDMMYYYY(text: string): string | undefined {
	const date = dayjs(text, "DD/MM/YYYY", true);
	if (!date.isValid()) return undefined;

	return date.format("YYYY-MM-DD");
}

import parsePhoneNumberFromString, { type CountryCode } from "libphonenumber-js";

export function toE164(raw: string, countryCode: CountryCode): string | null {
	const trimmed = (raw ?? "").trim();
	if (!trimmed) return null;

	try {
		const phoneNumber = parsePhoneNumberFromString(trimmed, countryCode);
		if (!phoneNumber || !phoneNumber.isValid()) return null;
		return phoneNumber.number; // E.164 format
	} catch {
		return null;
	}
}

export function fromE164ToNational(e164?: string | null): string {
	if (!e164) return "";

	try {
		const phoneNumber = parsePhoneNumberFromString(e164);
		return phoneNumber?.nationalNumber ?? "";
	} catch {
		return "";
	}
}
